// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__X0jSR","name":"ConsentHeader_name__20Ws6","birthday":"ConsentHeader_birthday__2O5wd","skeleton":"ConsentHeader_skeleton__W7ZU7"};